export default __webpack_public_path__ + "static/media/Icon2_On.3b152791.png";